module.exports = __webpack_public_path__ + "static/media/details-24-image-3.29f5db6c.jpg";